import { fromJS } from 'immutable';

import { isNullOrUndefined } from 'shared/lib/utils';

export function isImmutable(dataOrImmutable) {
  return 'toJS' in dataOrImmutable;
}

export function ensureImmutable(dataOrImmutable) {
  if (isNullOrUndefined(dataOrImmutable)) {
    return dataOrImmutable;
  }

  let immutable;

  if (!dataOrImmutable) {
    console.error('Empty object given to ensureImmutable()');
    return false;
  }

  if (isImmutable(dataOrImmutable)) {
    immutable = dataOrImmutable;
  } else {
    immutable = fromJS(dataOrImmutable);
  }

  return immutable;
}

export function ensureData(dataOrImmutable) {
  if (isNullOrUndefined(dataOrImmutable)) {
    return dataOrImmutable;
  }

  let data;

  if (!dataOrImmutable) {
    console.error('Empty data given to ensureData()');
    return false;
  }

  if (dataOrImmutable.toJS) {
    data = dataOrImmutable.toJS();
  } else {
    data = dataOrImmutable;
  }

  return data;
}

export function isNew(dataOrImmutable) {
  const immutable = ensureImmutable(dataOrImmutable);
  return immutable.get('id') === undefined;
}
